/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { notificationStatusEnumSchema } from "./notificationStatusEnumSchema.ts";
import { z } from "zod";

export const notificationStatusModelSchema = z.object({
    "status": z.lazy(() => notificationStatusEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - Planned</b>: Запланировано</li>\n<li><b>1 - Sent</b>: Отправлено</li>\n<li><b>2 - Error</b>: Ошибка</li>\n</ul>\n"),
"deliveryCount": z.number().int().describe("Число таймзон, в которые пуш доставлен")
    })